import { createAsyncThunk } from "@reduxjs/toolkit";
import { featureApi } from "api/feature";

export const getFeature = createAsyncThunk(
  "feature/getFeature",
  async (username: string, { rejectWithValue }) => {
    try {
      const response = await featureApi.toggleFeature(username);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
